import {CircularProgress} from '@sirius/ui-lib/src/blocks/CircularProgress';

export default CircularProgress;
